import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, ArrowRight } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const { refreshUser } = useAuth();
  const [status, setStatus] = useState("checking"); // checking | paid | pending
  const attempts = useRef(0);

  useEffect(() => {
    const sessionId = params.get("session_id");
    if (!sessionId) { setStatus("pending"); return; }
    let timer;
    const poll = async () => {
      attempts.current += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setStatus("paid");
          refreshUser?.().catch(() => {});
          return;
        }
      } catch (e) { /* ignore transient */ }
      if (attempts.current >= 15) { setStatus("pending"); return; }
      timer = setTimeout(poll, 2500);
    };
    poll();
    return () => clearTimeout(timer);
  }, [params, refreshUser]);

  return (
    <div className="min-h-screen bg-slate-50 grid place-items-center px-6">
      <div className="max-w-sm w-full bg-white rounded-3xl border border-slate-100 shadow-sm p-8 text-center" data-testid="payment-success">
        {status === "checking" && (
          <>
            <Loader2 className="w-10 h-10 text-blue-500 animate-spin mx-auto" />
            <p className="font-display font-bold text-xl text-slate-900 mt-5">Confermiamo il pagamento…</p>
            <p className="text-slate-500 text-sm mt-1">Solo un istante.</p>
          </>
        )}
        {status === "paid" && (
          <>
            <div className="w-16 h-16 rounded-full bg-emerald-100 text-emerald-600 grid place-items-center mx-auto"><CheckCircle2 className="w-9 h-9" /></div>
            <p className="font-display font-bold text-2xl text-slate-900 mt-5">Pagamento riuscito!</p>
            <p className="text-slate-500 text-sm mt-2">Il tuo piano è attivo. Ora hai accesso a tutte le funzionalità.</p>
            <Link to="/dashboard" data-testid="payment-success-dashboard" className="mt-6 w-full inline-flex items-center justify-center gap-2 bg-blue-500 text-white font-semibold rounded-full py-3">Vai alla dashboard <ArrowRight className="w-4 h-4" /></Link>
          </>
        )}
        {status === "pending" && (
          <>
            <p className="font-display font-bold text-xl text-slate-900">Stiamo elaborando il pagamento</p>
            <p className="text-slate-500 text-sm mt-2">Il tuo piano verrà attivato a breve. Puoi tornare alla dashboard.</p>
            <Link to="/dashboard" className="mt-6 w-full inline-flex items-center justify-center gap-2 bg-blue-500 text-white font-semibold rounded-full py-3">Vai alla dashboard <ArrowRight className="w-4 h-4" /></Link>
          </>
        )}
      </div>
    </div>
  );
}
